import loadable from "@loadable/component";
import { useParams } from "react-router";
import Spinner from "../../components/Reusable/Spinner";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useQueryClient } from "@tanstack/react-query";
import { patchApiData } from "../../helpers/AxiosInstance";
const EditRiderComponent = loadable(
  () => import("../../components/Rider/SwitchTab")
);
const EditRider = () => {
  const { id } = useParams();
  const queryClient = useQueryClient();
  const { data, isLoading } = useGetHook({
    queryKey: ["rider", `rider-${id}`],
    url: `${APIS.DRIVER}${id}/`,
    params: {},
  });

  const { data: userProfileType, isLoading: isProfileDataLoading } = useGetHook(
    {
      queryKey: [`user-profile`],
      url: `${APIS.USER_PROFILE}`,
      params: {
        user: id,
      },
    }
  );

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.DRIVER}${id}/`;
    let formData = {
      commission: values?.commission,
      commission_type: values?.commission_type,
    };
    try {
      const res = await patchApiData({ url, formData, setError });
      if (res?.status === 200) {
        queryClient.invalidateQueries({
          refetchType: "active",
          queryKey: ["rider"],
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Edit Rider</span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <EditRiderComponent
          handleEdit={handleEdit}
          userProfileType={userProfileType}
          profile={data}
        />
      )}
    </>
  );
};
export default EditRider;
